<script>
    import { formateToPrecision, formatScientificNumber } from "../../utils";
    import "../project-card/projectCard.css";
    export let saleCardDetails;

    $: progressBar =
        (saleCardDetails.totalRaised /
            saleCardDetails.price /
            saleCardDetails.totalSupply) *
        100 >
        100
            ? "100"
            : Math.round(
            (Number(
                    (saleCardDetails.totalRaised /
                        saleCardDetails.price /
                        saleCardDetails.totalSupply) *
                    100
                ) +
                Number.EPSILON) *
            100
        ) / 100;
</script>

<div class="flex column-direction progress-wrapper">
    <span class="flex">
        <span
        >Raised <small
        >${formatScientificNumber(
            formateToPrecision(saleCardDetails.totalRaised) ?? "0"
        )}</small
        ></span
        >
        <small class="ml-auto"
        >{saleCardDetails.totalRaised / saleCardDetails.price
            ? formateToPrecision(
                saleCardDetails.totalRaised / saleCardDetails.price
            )
            : 0}/{formateToPrecision(saleCardDetails.totalSupply)}</small
        >
    </span>
    <section class="flex">
        <span style={`width: ${progressBar}%`} class="progress-thumb" />
        <small class="percentage-text"
        >{formatScientificNumber(progressBar)}%</small
        >
    </section>
</div>

<style>
    .progress-wrapper {
        width: 100%;
        margin: 0;
        color: #fff;
        padding-bottom: 5px;
    }
    .progress-wrapper > span { margin: 0 0 3px}
    .progress-wrapper > span small { font-size: 10px}
    .progress-wrapper section {
        width: 100%;
        background: rgba(147, 9, 255, 0.3);
        height: 12px;
        border-radius: 6px;
        padding: 0;
        position: relative;
        overflow: hidden;
    }
    .progress-thumb {
        position: absolute;
        left: 0;
        border-radius: 50px;
        top: 0;
        height: 100%;
        background: linear-gradient(90deg, #00AFEC 0%, #3178F2 24.62%, #5B48F8 49.14%, #7925FC 70.63%, #8C10FE 88.3%, #9309FF 99.89%);
        opacity: 0.5;
        overflow: hidden;
    }
    .percentage-text {
        position: absolute;
        right: 6px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 10px;
    }
</style>
